import React from 'react';
import { useInjury } from '../contexts/InjuryContext';

const InjuryBadge = ({ mlbId }) => {
  const injury = useInjury(mlbId);
  if (!injury) return null;

  const status = injury.status || '';
  let label, colorClass;

  if (status.includes('Day-To-Day')) {
    label = 'DTD';
    colorClass = 'bg-yellow-500/20 text-yellow-400 border border-yellow-500/30';
  } else if (status.includes('60-Day') || status === 'Out') {
    label = '60-IL';
    colorClass = 'bg-red-500/20 text-red-400 border border-red-500/30';
  } else if (status.includes('15-Day')) {
    label = '15-IL';
    colorClass = 'bg-orange-500/20 text-orange-400 border border-orange-500/30';
  } else {
    label = 'IL';
    colorClass = 'bg-orange-500/20 text-orange-400 border border-orange-500/30';
  }

  const tooltip = injury.description
    ? `${injury.description}${injury.return_date ? ` · ETA: ${injury.return_date}` : ''}`
    : status;

  return (
    <span
      className={`inline-flex items-center px-1 py-0 rounded text-xs font-bold ml-1 leading-tight ${colorClass}`}
      title={tooltip}
    >
      {label}
    </span>
  );
};

export default InjuryBadge;
